import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

// Removed EventBus import since we're using the profile update helper now
//import images
// import avatar1 from "../../assets/images/users/avatar-1.jpg";
import { createSelector } from 'reselect';
import { baseURL } from '../../utils/usermanagement';
import axios from '../../axiosConfig';  // Add axios import
import { getBestProfilePhoto } from '../../utils/profilePhotoUtils';
import { useProfileUpdates } from '../../hooks/useProfileUpdates';

const ProfileDropdown = () => {
    const navigate = useNavigate();
  
    const profiledropdownData = createSelector(
        (state) => state.Profile,
        (user) => user.user
      );
    // Inside your component
    const user = useSelector(profiledropdownData);

    // Use the profile updates hook
    const { profileData, avatarUrl, userName, userRole, isLoading } = useProfileUpdates('profileDataRefreshed');
    
    // Removed unused state variables since the hook handles everything

    // Removed EventBus usage since the hook handles all profile updates

    // The useProfileUpdates hook handles all profile update subscriptions automatically
    
    // Removed complex image accessibility testing since the hook handles profile photo selection

    // The useProfileUpdates hook automatically provides the latest profile data
    // including the best profile photo based on priority logic

    // The useProfileUpdates hook automatically handles initial loading and updates

    // Debug useEffect to log state changes
    useEffect(() => {
        console.log('ProfileDropdown - State changed:', {
            avatarUrl,
            userName,
            userRole,
            isLoading,
            profileData: profileData ? Object.keys(profileData) : null
        });
    }, [avatarUrl, userName, userRole, isLoading, profileData]);

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    
    const handleLogout = () => {
        // 清除所有存储
        sessionStorage.clear();
        localStorage.clear();
        
        // 清除axios默认请求头
        delete axios.defaults.headers.common["Authorization"];
        
        // 触发全局状态更新
        window.dispatchEvent(new Event('storage'));
        
        // 强制跳转并替换历史
        navigate('/login', { 
            replace: true,
            state: { timestamp: Date.now() } // 防止缓存
        });
    };
      
    console.log('userRole', userRole);
    console.log('ProfileDropdown - Current state:', { 
        avatarUrl, 
        userName, 
        userRole, 
        isLoading,
        profileData: profileData ? Object.keys(profileData) : null
    });
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <img 
                            className="rounded-circle header-profile-user" 
                            src={avatarUrl || 'https://via.placeholder.com/32x32/007bff/ffffff?text=U'}
                            alt="Header Avatar" 
                            title="Profile Photo"
                            style={{ 
                                width: '32px', 
                                height: '32px', 
                                objectFit: 'cover',
                                border: '2px solid #fff',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                            }}
                            onLoad={() => {
                                console.log('ProfileDropdown - Image loaded successfully with URL:', avatarUrl);
                            }}
                            onError={(e) => {
                                console.error('ProfileDropdown - Image failed to load:', e.target.src);
                            }}
                        />
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{userName}</span>
                            <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{userRole}</span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Welcome {userName}!</h6>
                   {(userRole=="employee3"||userRole=="employee2"||userRole=="superadmin")?<DropdownItem className='p-0'>
                        <Link to="/dashboard" className="dropdown-item">
                            <i className="mdi mdi-home text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Dashboard</span>
                        </Link>
                    </DropdownItem>:""} 
                    <DropdownItem className='p-0'>
                        <Link 
                          to="/profile" 
                          className="dropdown-item"
                          onClick={(e) => {
                            e.preventDefault(); // 阻止默认导航
                            window.dispatchEvent(new Event('reloadProfile'));
                            navigate('/profile'); // 手动执行导航
                          }}
                        >
                          <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                          <span className="align-middle">Account Settings</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to= "/chat" className="dropdown-item">
                            <i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i> <span
                                className="align-middle">Messages</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to="/order-list" className="dropdown-item">
                            <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i> <span
                                className="align-middle">Order History</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to= "/seedpower-points" className="dropdown-item">
                            <i
                                className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle">My ExiaPoints </span>
                        </Link>
                    </DropdownItem >
                    <DropdownItem className='p-0'>
                        <Link to= "/404-alt" className="dropdown-item">
                            <i
                                className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle">Display Cabinet</span>
                        </Link>
                    </DropdownItem> 
                    {/* <DropdownItem className='p-0'>
                        <Link to="#" className="dropdown-item">
                            <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i> <span
                                className="align-middle">Taskboard</span>
                        </Link>
                    </DropdownItem> */}
                    <div className="dropdown-divider"></div> 
                    <DropdownItem className='p-0'>
                        <Link to= "/404-alt" className="dropdown-item">
                            {/* <span  className="badge bg-success-subtle text-success mt-1 float-end">New</span> */}
                                <i  className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i> <span
                                        className="align-middle">Trading Center</span>
                        </Link>
                    </DropdownItem>
                    {/* <DropdownItem className='p-0'>
                        <Link to= "/auth-lockscreen-basic" className="dropdown-item">
                            <i
                                className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Lock screen</span>
                        </Link>
                    </DropdownItem> */}
                    <DropdownItem className='p-0' onClick={handleLogout}>
                        <div className="dropdown-item">
                            <i
                                className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle" data-key="t-logout">Logout</span>
                        </div>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;